export const isLoggedIn = () => {
    return Boolean(useUser().value.email);
};
